// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SGrs","top":"styles_top__NOgIb","left":"styles_left__3gxGu","description":"styles_description__1x4vY"};